<template>
	<CCard>
		<CCardBody>
			<CRow>
				<CCol><h5>Trends in spend change</h5></CCol>
				<CCol>
					<CButtonGroup class="float-right">
						<CButton
							color="white"
							size="sm"
							:class="{ selected: isTop10 }"
							class="nextButton"
							>Top 10</CButton
						>
						<CButton
							color="white"
							size="sm"
							:class="{ selected: isNext10 }"
							class="nextButton"
							>Next 10</CButton
						>
						<CButton
							color="white"
							size="sm"
							:class="{ selected: isLast10 }"
							class="nextButton"
							>Last 10</CButton
						>
					</CButtonGroup>
				</CCol>
			</CRow>
			<CRow class="px-3">
				<CCol sm="4" class="px-2">
					<CRow class="each-card">
						<CCol sm="9" class="light-blue">
							<p class="bill-text">{{ activeProjects.total }}</p>
							<p class="bill-sub-text">
								{{ activeProjects.count }} Estimate in last 365 days
							</p>
						</CCol>
						<CCol sm="3" class="dark-blue">
							<p class="bill-text">$2,000</p>
						</CCol>
					</CRow>
				</CCol>
				<CCol sm="4" class="px-2">
					<CRow class="each-card">
						<CCol sm="4" class="light-orange">
							<p class="bill-text">{{ overdueProjects.total }}</p>
							<p class="bill-sub-text">{{ overdueProjects.count }} Overdue</p>
						</CCol>
						<CCol sm="8" class="dark-orange">
							<p class="bill-text">$2,000</p>
						</CCol>
					</CRow>
				</CCol>
				<CCol sm="4">
					<CRow class="each-card">
						<CCol sm="12" class="green">
							<p class="bill-text">
								{{ last30DaysExpense.totalExpense }}
							</p>
							<p class="bill-sub-text">
								{{ last30DaysExpense.count }} Paid Last 30 Days
							</p>
						</CCol>
					</CRow>
				</CCol>
			</CRow>
		</CCardBody>
	</CCard>
</template>

<script>
import gql from "graphql-tag";
import _ from "../../Utility/utility";

export default {
	data() {
		return {
			isTop10: true,
			isNext10: false,
			isLast10: false,

			last30DaysExpense: {
				count: 0,
				totalExpense: 0,
			},

			activeProjects: {
				total: 0,
				count: 0,
			},

			overdueProjects: {
				total: 0,
				count: 0,
			},
		};
	},
	methods: {
		getDate(now) {
			let month = now.getMonth() + 1;
			let date = now.getDate();
			if (month < 10) month = "0" + month;
			if (date < 10) date = "0" + date;
			return `${now.getFullYear()}-${month}-${date}`;
		},
		getCircularDate(days) {
			let d1 = new Date();
			d1.setDate(d1.getDate() - days);
			let from = this.getDate(d1);

			let d2 = new Date();
			let to = this.getDate(d2);
			return { from, to };
		},
		getLast30DaysExpense() {
			const { from, to } = this.getCircularDate(30);

			this.$apollo
				.mutate({
					mutation: LAST_30_DAYS_EXPENSE,
					variables: {
						from,
						to,
					},
				})
				.then((res) => {
					const result =
						res.data.spendmd_db_spend_data_final_aggregate.aggregate;
					this.last30DaysExpense.count = result.count;
					this.last30DaysExpense.totalExpense = _.getMoneyFormat(
						_.parseAmountToInt(_.removeDecimals(result.sum.net_amount))
					);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getLast365DaysProjectTotal() {
			const { from, to } = this.getCircularDate(365);

			this.$apollo
				.mutate({
					mutation: GET_ACTIVE_PROJECTS_TOTAL,
					variables: {
						from,
						to,
					},
				})
				.then((res) => {
					const result = res.data.spendmd_db_project_aggregate.aggregate;
					this.activeProjects.count = result.count;
					this.activeProjects.total = _.getMoneyFormat(
						_.parseAmountToInt(_.removeDecimals(result.sum.spendmd_opportunity))
					);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getOverdueProjects() {
			const today = this.getDate(new Date());

			this.$apollo
				.mutate({
					mutation: GET_OVERDUE_PROJECTS,
					variables: {
						today,
					},
				})
				.then((res) => {
					const result = res.data.spendmd_db_project_aggregate.aggregate;
					this.overdueProjects.count = result.count;
					this.overdueProjects.total = _.getMoneyFormat(
						_.parseAmountToInt(_.removeDecimals(result.sum.spendmd_opportunity))
					);
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	beforeMount() {
		this.getLast30DaysExpense();
		this.getLast365DaysProjectTotal();
		this.getOverdueProjects();
	},
};

const LAST_30_DAYS_EXPENSE = gql`
	query ($from: date!, $to: date!) {
		spendmd_db_spend_data_final_aggregate(
			where: { doc_date: { _lte: $to, _gte: $from } }
		) {
			aggregate {
				sum {
					net_amount
				}
				count
			}
		}
	}
`;

const GET_ACTIVE_PROJECTS_TOTAL = gql`
	query ($from: date!, $to: date!) {
		spendmd_db_project_aggregate(
			where: { project_start: { _lte: $to, _gte: $from } }
		) {
			aggregate {
				sum {
					spendmd_opportunity
				}
				count
			}
		}
	}
`;

const GET_OVERDUE_PROJECTS = gql`
	query ($today: date) {
		spendmd_db_project_aggregate(
			where: { target_date: { _lt: $today }, status: { _neq: "Completed" } }
		) {
			aggregate {
				sum {
					spendmd_opportunity
				}
				count
			}
		}
	}
`;
</script>

<style scoped>
.selected {
	background-color: #9ca8a9 !important;
	color: #ffffff !important;
}
.nextButton {
	padding: 15px 25px;
	margin: auto 2px;
	background-color: white !important;
	color: #1f2621 !important;
}
.each-col {
	background: var(--unnamed-color-f0f3f3) 0% 0% no-repeat padding-box;
	background: #f0f3f3 0% 0% no-repeat padding-box;
	border-radius: 5px;
	opacity: 1;
}
.each-card {
	height: 100%;
	width: 100%;
	border-radius: 0px 0px 5px 5px;
	opacity: 1;
}
.light-blue {
	background: linear-gradient(180deg, #85ebff 0%, #648dff 100%);
}
.dark-blue {
	background: #6590ff 0% 0% no-repeat padding-box;
}
.light-orange {
	background: linear-gradient(180deg, #ffe185 0%, #ff6464 100%);
}
.dark-orange {
	background: #ff6f67 0% 0% no-repeat padding-box;
}
.green {
	background: linear-gradient(180deg, #85ffb3 0%, #3db88b 100%);
}
.bill-text {
	color: var(--unnamed-color-ffffff);
	text-align: left;
	font: normal normal medium 20px/70px Muller;
	letter-spacing: 0px;
	color: #ffffff;
	opacity: 1;
	font-size: 20px;
	margin-bottom: 0;
}
.bill-sub-text {
	text-align: left;
	font: normal normal normal 12px/26px Lato;
	letter-spacing: 0px;
	color: #ffffff;
	opacity: 1;
	margin-bottom: 0;
}
</style>